import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {appHeader_template} from "../components/templates/appHeader_template";
import {vnApp_emaki} from "../components/vnApp_emaki";

declare var page: any;
declare var ko: any;
export class header extends vnModule_knockoutJS{


    public appHeader: appHeader_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected getModuleName(){
        return "header";
    }

    buildContent() : Array<Element>{

        let vnApp = this.getVnAppZone().app;

        //
        // Only if were logged in
        if(vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {

            this.appHeader = new appHeader_template("mainHeader", this.viewModel, this);
            this.appHeader.handleMissingUserCountryStatePopup(vnApp.loggedUser.user.id, vnApp.loggedUser.user.valnet_user.state);
            // set picture
            if( vnApp.loggedUser.user.valnet_user.pictureUrl ){
                this.appHeader.setUserImageSrc(vnApp.loggedUser.user.valnet_user.pictureUrl);
            }
            else{
                this.appHeader.setUserImageSrc("/assets/images/default-user.png");
            }

            // set full name
            this.appHeader.setUserFullName(vnApp.loggedUser.user.valnet_user.firstName +' '+ vnApp.loggedUser.user.lastName);

            // set profile page link
            this.appHeader.setProfilePageLink("/users/edit/"+ vnApp.loggedUser.user.id);

            return [this.appHeader.build()]
        }
        else{
            return [document.createElement("div")];
        }
    }


    public fillPage() : void{
        let vnApp = this.getVnAppZone().app;
        if(vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {
            this.getMenuData();
        }
    }


    public getMenuData(): void{

        if( 'getMenuData' in this.XHRHdls ){
            this.XHRHdls['getMenuData'].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON({menu: 'main'}));
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(subViewModel)]);

        let usrReq_url: string = '/api/emaki/menu';
        this.XHRHdls['getMenuData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getMenuData'].onReadyStateFunction = this.onMenuDataRequestReturn;
        this.XHRHdls['getMenuData'].execute();

    }

    protected onMenuDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.appHeader.setMenuItems(response.formMenu);

                /*let idBrand = obj.getVnAppZone().app.params.idBrand;
                if(idBrand){
                    obj.getUserSessionTrackerData(idBrand);
                }*/

            });
        }
    }

    public getUserSessionTrackerData(idBrand): void{

        if( 'getUserSessionTrackerData' in this.XHRHdls ){
            this.XHRHdls['getUserSessionTrackerData'].cancelAndReset();
        }

        //let subViewModel = JSON.parse(ko.toJSON({menu: 'main'}));
        let usrReq_params: Array<Array<string>> = [];
        let idArticle = null;

        if(document.location.pathname.includes("/articles/edit/") && this.getVnAppZone().app.params.id){
            idArticle = this.getVnAppZone().app.params.id;
        }
        let data = { idArticle: idArticle};
        usrReq_params.push(["data", JSON.stringify(data)]);

        let usrReq_url: string = '/api/brand/'+idBrand+'/user/session-tracker-data/get/';
        this.XHRHdls['getUserSessionTrackerData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getUserSessionTrackerData'].onReadyStateFunction = this.onUserSessionDataRequestReturn;
        this.XHRHdls['getUserSessionTrackerData'].execute();

    }

    protected onUserSessionDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                let zoneContent = obj.getVnAppZone().app.getZoneByName("Content");
                let loadedModule = zoneContent.loadedModule;

                if(response.data && response.data.hasOwnProperty('articleCount')){

                    let data = response.data;

                    obj.setTrackerData(data, obj.appHeader);


                    if(loadedModule && loadedModule.getModuleName() == "articles_edit_new"){

                        obj.setTrackerData(data, loadedModule.articlesEdit);

                        if( obj.getVnAppZone().app.loggedUser.user.valnet_user.pictureUrl ){
                            loadedModule.articlesEdit.setUserPicture(obj.getVnAppZone().app.loggedUser.user.valnet_user.pictureUrl);
                        }
                        else{
                            loadedModule.articlesEdit.setUserPicture("/assets/images/default-user.png");
                        }
                    }

                }else{
                    obj.hideSessionTracker(obj.appHeader);

                    if(loadedModule && loadedModule.getModuleName() == "articles_edit_new"){

                        obj.hideSessionTracker(loadedModule.articlesEdit);
                    }
                }
                //obj.appHeader.setMenuItems(response.formMenu);
            });
        }
    }

    public setTrackerData(data, template){

        template.setIsSessionTrackerVisible(true);

        if(data.articleCount){
            template.setArticleCount(data.articleCount);
        }
        if(data.sessionsPerArticle){
            template.setSessionsPerArticle(data.sessionsPerArticle.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }));
        }
        if(data.articleGoalProgressPercentage){
            template.setArticleGoalProgressPercentage(data.articleGoalProgressPercentage);
        }
        if(data.sessionGoalProgressPercentage){
            template.setSessionGoalProgressPercentage(data.sessionGoalProgressPercentage);
        }
        if(data.isUserHasTier2Rates){
            template.setIsUserHasTier2Rates(data.isUserHasTier2Rates);
        }else{
            template.setIsUserHasTier2Rates(false);
        }
        if(data.articleGoal){
            template.setArticleGoal(data.articleGoal);
        }
        if(data.roleName){
            template.setRoleName(data.roleName);
        }
        if(data.contentTypeName){
            template.setContentTypeName(data.contentTypeName);
        }
        if(data.monthName){
            template.setMonthName(data.monthName);
        }
        if(data.sessionsPerArticleTarget){
            //let formattedNumber = this.formatToK(data.sessionsPerArticleTarget);
            template.setSessionsPerArticleTarget(data.sessionsPerArticleTarget.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }));
        }
        if(data.tier2SessionsPerArticleTarget){
            //let formattedTier2Number = this.formatToK(data.tier2SessionsPerArticleTarget);
            template.setTier2SessionsPerArticleTarget(data.tier2SessionsPerArticleTarget.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }));
        }
        if(data.tier2SessionGoalProgressPercentage){

            template.setTier2SessionGoalProgressPercentage(data.tier2SessionGoalProgressPercentage);
        }
        if(data.tier1Amount){

            template.setTier1Amount(data.tier1Amount.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }));
        }
        if(data.tier2Amount){

            template.setTier2Amount(data.tier2Amount.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }));
        }
        if(data.outputTransactionsTotal){

            template.setOutputTransactionsTotal(data.outputTransactionsTotal);
        }
        if(data.brandSessionTarget){

            template.setBrandSessionTarget(data.brandSessionTarget.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }));
        }
        if(data.brandContentTypeSessionTarget){

            template.setBrandContentTypeSessionTarget(data.brandContentTypeSessionTarget.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }));
        }
        if(data.brandProgressPercentage){

            template.setBrandProgressPercentage(data.brandProgressPercentage);
        }
        if(data.contentTypePercentage){

            template.setContentTypeProgressPercentage(data.contentTypePercentage);
        }
    }

    public hideSessionTracker(template){

        template.setIsSessionTrackerVisible(false);
    }


    private formatToK(num) {
        if (num >= 1000) {
            return Math.floor(num / 1000) + 'K';
        } else {
            return num.toString();
        }
    }

    public logOut(){
        let _mythis = this;

        if( "logOut" in this.XHRHdls ){
            this.XHRHdls["logOut"].cancelAndReset();
        }

        // loading the page if the user is logged in
        let loginReq_url: string = '/api/access/logout/';
        let loginReq_Params: Array<Array<string>> = [];
        this.XHRHdls["logOut"] = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        this.XHRHdls["logOut"].onReadyStateFunction = (function(req, obj){

            return function(){

                if (req.request.readyState == 4) {

                    if(  req.request.status == 200  ){
                        page.redirect('/');
                    }
                }
            }
        });
        this.XHRHdls["logOut"].execute();
    }

    public setHeaderTitle(title: string){
        this.appHeader.setHeaderTitle(title);
    }

    public setBrandClass(brandClass: string){
        this.appHeader.setBrandClass(brandClass);
    }

    public setBrandName(brandName: string){
        this.appHeader.setBrandName(brandName);
    }

    public setBrandShortName(brandShortName: string){
        this.appHeader.setBrandShortName(brandShortName);
    }

    public setBrandDomain(brandDomain: string){

        this.appHeader.setBrandDomain(brandDomain);

        if (brandDomain.length > 0) {
            if (!brandDomain.startsWith('https://')) {
                brandDomain = 'https://'+brandDomain;
            }
            window.sessionStorage.setItem('currentBrandDomain', brandDomain);
        } else {
            window.sessionStorage.removeItem('currentBrandDomain');
        }
    }

    public isOfRole(role: Number) {
        let show = false;

        let vnApp = this.getVnAppZone().app;
        let roles: Array<any> = this.getVnAppZone().getApp().loggedUser.user.valnet_user.roles;
        let roleIds = [];

        for (let role of roles) {
            roleIds.push(role.id);
        }
        if (roleIds.indexOf(role) > -1) {
            show = true;
        }

        return show;
    }
}



// WEBPACK FOOTER //
// ./js/modules/header.ts